import { createSelector } from '@reduxjs/toolkit';

// First select the relevant part from the state
export const manageUsersState = (state) => state.manageUsers;
export const selectUsersListingData = createSelector(manageUsersState, (state) => state);

